import { render, staticRenderFns } from "./Template-01.vue?vue&type=template&id=8cd05bcc&scoped=true&"
import script from "./Template-01.vue?vue&type=script&lang=js&"
export * from "./Template-01.vue?vue&type=script&lang=js&"
import style0 from "./Template-01.vue?vue&type=style&index=0&id=8cd05bcc&lang=less&scoped=true&"
import style1 from "./Template-01.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd05bcc",
  null
  
)

export default component.exports